var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "affilate",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__partnersky_program"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.971.05 1.16.841 1.971 1.97 1.971 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  })))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "basket",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 8.732h-4.177L12 1.91 5.177 8.732H1v2.357h1.377l3.667 11h11.914l3.666-11H23V8.732zM12 5.243l3.489 3.489H8.511L12 5.243zM7.743 19.732l-1.31-3.928h11.134l-1.31 3.928H7.743zm10.611-6.286H5.647l-.786-2.356h14.277l-.784 2.356z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "campaign",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 11H6v-2h12v2zm0-4H6V7h12v2z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "chart",
    viewBox: "0.5 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4475__x28_Stroke_x29_",
    d: "M16.822 1.786H23.5v20.428h-6.678V1.786zm2.357 2.357v15.714h1.965V4.143h-1.965z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4477__x28_Stroke_x29_",
    d: "M9.358 6.893h6.678v15.321H9.358V6.893zm2.357 2.357v10.607h1.965V9.25h-1.965z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4478__x28_Stroke_x29_",
    d: "M1.5 12.786h6.679v9.428H1.5v-9.428zm2.357 2.357v4.715h1.964v-4.715H3.857z"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "chat",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__speach"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25__x28_Stroke_x29_",
    d: "M8 8.802h24v17.567h-7.479L20 31.198l-4.521-4.829H8V8.802zm2.667 2.667v12.233h5.97L20 27.296l3.364-3.594h5.969V11.469H10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4447",
    d: "M14.223 16.803h2.666v2.666h-2.666v-2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4448",
    d: "M18.667 16.803h2.666v2.666h-2.666v-2.666z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4449",
    d: "M23.111 16.803h2.666v2.666h-2.666v-2.666z"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "cite",
    viewBox: "12 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.401 10.048c-2.703 0-4.342 1.342-5.066 3.178-.883-2.07-2.562-3.134-4.886-3.178-4.536 0-6.095 3.766-5.315 7.33.284 1.278 2.197 4.708 1.417 8.271-.283 1.479-1.063 2.959-2.551 4.304 3.189 0 5.882-1.681 7.866-3.833 1.985-2.132 3.313-4.773 3.876-6.851.596 1.661 1.285 3.988.762 6.38-.283 1.479-1.063 2.959-2.552 4.304 3.189 0 5.883-1.681 7.866-3.833C33.512 23.228 35 19.395 35 17.31c0-4.774-2.056-7.195-5.599-7.262z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "click",
    viewBox: "0.5 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__click"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_204__x28_Stroke_x29_",
    d: "m4.871 1 15.258 11.625-4.659 1.346 3.219 5.27L12.437 23l-3.546-5.759-4.02 3.106V1zm2.437 4.921v9.463l2.237-1.729 3.702 6.013 2.082-1.252-3.604-5.9 3.073-.888-7.49-5.707z"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22.999C5.925 22.999 1 18.074 1 12 1 5.925 5.925 1.001 12 1.001c6.074 0 11 4.924 11 10.999 0 6.074-4.926 10.999-11 10.999zM13 5.5h-2v6.914l3.999 3.999 1.414-1.414-3.414-3.413L13 5.5z"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 19.37 19.37 22 12 14.63 4.63 22 2 19.37 9.37 12 2 4.63 4.63 2 12 9.37 19.37 2 22 4.63 14.63 12z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "color-clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12zm0 20.4a8.4 8.4 0 1 1 0-16.8 8.4 8.4 0 0 1 0 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAFD82",
    d: "M13.875 6h-3.75v7.875H18v-3.75h-4.125V6z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "color-online",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__online"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#DAFD82",
    d: "M11.196 32a3.186 3.186 0 0 0 3.199-3.182 3.198 3.198 0 0 0-6.394 0A3.185 3.185 0 0 0 11.196 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#FFF",
    d: "M27.383 31.992h4.616C31.999 18.767 21.233 8 8.001 8v4.601c10.686 0 19.382 8.7 19.382 19.391z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#FFF",
    d: "M19.227 31.993h4.621c0-8.734-7.11-15.839-15.847-15.839v4.6c2.997 0 5.813 1.17 7.935 3.292a11.152 11.152 0 0 1 3.291 7.947z"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "converse",
    viewBox: "0.5 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__konverzni_pomer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4479",
    d: "M1.357 3h22.285v2.571H1.357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4480",
    d: "M3.928 8.143h17.143v2.571H3.928z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4481",
    d: "M7.357 13.285h10.285v2.572H7.357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4482",
    d: "M9.5 18.429h6V21h-6z"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "credit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__kredit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "danger",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm5.25 15.869-1.381 1.381L12 13.381 8.131 17.25 6.75 15.869 10.619 12 6.75 8.131 8.131 6.75 12 10.619l3.869-3.869 1.381 1.381L13.381 12l3.869 3.869z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "dashboard",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 22v-9h4v9h6V11h2L12 2 2 11h2v11h6z"
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "delete",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 3V1h-4v2H4v2h16V3zM5 20.715C5 21.971 6.05 23 7.333 23h9.333C17.95 23 19 21.971 19 20.715V7H5v13.715zM14 10h2v10h-2V10zm-6 0h2v10H8V10z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "document",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.714 23.857h8.571v2.571h-8.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.969 8H9.714v24h20.571V17.486L20.969 8zm-.112 3.557 5.768 5.872h-5.768v-5.872zm-8.571 17.872V10.571h6V20h9.429v9.429H12.286z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "-2 -2 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10.833 1.666v9.655L15 7.154l1.179 1.179L10 14.512 3.821 8.333 5 7.154l4.167 4.167V1.666h1.666zM5 13.334H3.333v5h13.334v-5h-1.668v3.332H5v-3.332z"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "email",
    viewBox: "4 4 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 20.431c-.71 0-1.421-.233-2.026-.705L5 12.748v9.746c0 1.138.923 2.062 2.063 2.062h17.874c1.14 0 2.063-.924 2.063-2.062v-9.746l-8.973 6.982a3.301 3.301 0 0 1-2.027.701zM5.7 10.938l9.118 7.094c.696.541 1.67.541 2.365 0l9.119-7.094c.401-.344.698-.873.698-1.431a2.063 2.063 0 0 0-2.063-2.063H7.063C5.923 7.444 5 8.368 5 9.507c0 .558.258 1.087.7 1.431z"
  })))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "-4 -4 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.001.5C3 .5-1.27 3.61-3 8c1.73 4.391 6 7.5 11 7.5s9.269-3.109 11-7.5C17.27 3.61 13.001.5 8.001.5zm0 12.501C5.24 13.001 3 10.76 3 8s2.24-5 5-5c2.759 0 5 2.24 5 5s-2.24 5.001-4.999 5.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.001 5c-1.661 0-3 1.34-3 3s1.339 3 3 3C9.661 11 11 9.66 11 8S9.661 5 8.001 5z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "feed",
    viewBox: "4 4.5 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__feed"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.222 26.5a2.139 2.139 0 0 1-1.569-.652A2.148 2.148 0 0 1 6 24.278V8.722c0-.611.218-1.134.653-1.569s.959-.652 1.569-.653h12.223L26 12.056v12.223c0 .61-.217 1.135-.652 1.569a2.131 2.131 0 0 1-1.569.652H8.222zm2.222-4.445h11.11v-2.222h-11.11v2.222zm0-4.444h11.11v-2.223h-11.11v2.223zm8.889-4.444h4.445l-4.445-4.444v4.444zm-8.889 0H16v-2.222h-5.556v2.222z"
  })))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "grow",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4 2.4H1v19.2h21.601v-2.4H3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.001 3.2v2.4h3.947l-5.205 5.391-2.591-2.693-6.247 6.541 1.736 1.658 4.517-4.73 2.581 2.683 6.862-7.106V11.2H23v-8z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "hand",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.354 6.313a2.205 2.205 0 0 0-2.124-.574 2.213 2.213 0 0 0-2.19-1.905c-.191 0-.38.025-.563.073a2.057 2.057 0 0 0-.146-.544 2.203 2.203 0 0 0-4.078 0 2.24 2.24 0 0 0-.147.543 2.209 2.209 0 0 0-2.771 2.136v4.866a2.545 2.545 0 0 0-3.032-.31 2.204 2.204 0 0 0-.789 2.976c1.712 3.044 2.734 4.826 3.04 5.297.061.093.121.186.182.277v.002a6.334 6.334 0 0 0 4.991 2.843.773.773 0 0 0 .108.007h1.835a6.333 6.333 0 0 0 6.333-6.334V7.875a2.217 2.217 0 0 0-.649-1.562zm-1.018 9.353a4.67 4.67 0 0 1-4.666 4.668h-1.645a4.675 4.675 0 0 1-3.896-2.1 15.966 15.966 0 0 0-.177-.271l-.001-.001c-.267-.41-1.252-2.126-2.984-5.204a.545.545 0 0 1 .194-.731.882.882 0 0 1 1.044.104l1.131 1.426v.193h1.667V6.042a.54.54 0 1 1 1.081 0v6.792h1.667V4.208a.558.558 0 0 1 .159-.384.544.544 0 0 1 .768 0 .537.537 0 0 1 .158.384v8.625h1.665V6.027a.544.544 0 0 1 1.085.015v6.792h1.666V7.875a.542.542 0 1 1 1.084 0v7.791z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__zkusenosti"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29_",
    d: "M8 16.091c0-4.017 3.256-7.289 7.268-7.289A7.24 7.24 0 0 1 20 10.557a7.236 7.236 0 0 1 4.732-1.755c4.012 0 7.268 3.272 7.268 7.289a7.25 7.25 0 0 1-2.213 5.234L20 31.198l-9.967-10.052-.008-.009A7.272 7.272 0 0 1 8 16.091zm7.268-4.717c-2.584 0-4.697 2.112-4.697 4.717 0 1.221.461 2.376 1.305 3.262L20 27.548l7.98-8.053.011-.009a4.684 4.684 0 0 0 1.438-3.395c0-2.605-2.112-4.717-4.696-4.717-1.48 0-2.836.689-3.714 1.829L20 14.524l-1.019-1.322a4.673 4.673 0 0 0-3.713-1.828z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29__x5F_2",
    d: "m26.96 15.597-7 7.494-4.564-4.667 1.838-1.798 2.683 2.743 5.164-5.528 1.879 1.756z"
  })))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__napoveda"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.7 21.9c0 .55.439 1.1 1.1 1.1h4.4c.659 0 1.1-.55 1.1-1.1v-1.1H8.7v1.1zM12 1C7.71 1 4.3 4.41 4.3 8.7c0 2.64 1.32 4.95 3.3 6.271V17.5c0 .55.44 1.1 1.1 1.1h6.6c.66 0 1.101-.55 1.101-1.1v-2.529c1.979-1.431 3.3-3.741 3.3-6.271A7.654 7.654 0 0 0 12 1z"
  })))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "home-2",
    viewBox: "-1.5 -2 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5-1.414-.914 10h2.835v10.999h6.684V13h3.789v7.999h6.685V10h2.835L10.5-1.414zM17.079 8v11h-2.684v-7.999h-7.79V19H3.921V8h-.006L10.5 1.414 17.086 8h-.007z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 22v-9h4v9h6V11h2L12 2 2 11h2v11h6z"
  })))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "indicator",
    viewBox: "0.5 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.873 0 .5 5.373.5 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12zm7.778 19.778C18.286 21.77 15.539 23 12.5 23s-5.786-1.23-7.778-3.222S1.5 15.039 1.5 12s1.23-5.786 3.222-7.778S9.461 1 12.5 1s5.786 1.23 7.778 3.222S23.5 8.961 23.5 12s-1.23 5.786-3.222 7.778z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "login",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__user"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 12,
    cy: 7,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1",
    d: "M13 15h-2a8 8 0 0 0-8 8h18a8 8 0 0 0-8-8z"
  })))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "meter",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 8C13.372 8 8 13.372 8 20s5.372 12 12 12 12-5.372 12-12S26.628 8 20 8zm0 2.667A9.334 9.334 0 0 1 29.333 20c0 .768-.103 1.509-.276 2.222H22.23l4.514-6.565-2.197-1.51-5.553 8.075h-8.049A9.294 9.294 0 0 1 10.668 20c-.001-5.154 4.178-9.333 9.332-9.333zm0 18.666c-3.359 0-6.296-1.78-7.939-4.444h8.172l.111.077.053-.077h7.543c-1.644 2.664-4.581 4.444-7.94 4.444z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "-2 -2 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4464",
    d: "M2.5 9.167h15v1.667h-15z"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "money",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29_",
    d: "M11.072 11.5a3.531 3.531 0 0 1 4.999 0 3.534 3.534 0 1 1-4.999 5 3.531 3.531 0 0 1 0-5zm2.5 1.321A1.182 1.182 0 0 0 12.393 14a1.18 1.18 0 0 0 2.357 0 1.17 1.17 0 0 0-.346-.833 1.168 1.168 0 0 0-.832-.346z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4475__x28_Stroke_x29_",
    d: "M4.142 6.929H23v14.144H4.142V6.929zm2.357 2.357v9.428h14.144V9.286H6.499z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45__x28_Stroke_x29_",
    d: "M1 3.785h17.679v2.357H3.356v9.821H1V3.785z"
  })))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "open",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.364 8v19.637H32V8H12.364zm17.018 17.019h-14.4v-14.4h14.4v14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4 22.452 5.618-5.618v3.384h2.619v-7.854h-7.855v2.618h3.385L17.548 20.6zm-8.782-.052H8V32h9.6v-2.618h-6.982z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.197 1.09c.351 0 .688.144.933.398l2.938 3.026c.257.266.386.614.386.962s-.129.696-.387.962L5.868 8.705a.284.284 0 0 0-.049.326c.908 1.805 2.226 3.622 3.814 5.259 1.589 1.637 3.354 2.997 5.105 3.931.053.027.11.036.167.027a.272.272 0 0 0 .15-.079l2.199-2.267c.258-.264.596-.397.934-.397s.675.134.934.399l2.937 3.025c.257.266.386.613.386.962 0 .347-.129.695-.386.962l-.512.526c-1.462 1.507-3.824 2.016-6.698 1.302-2.859-.712-5.834-2.532-8.369-5.143-2.535-2.611-4.303-5.678-4.993-8.623-.693-2.96-.199-5.394 1.264-6.901l.509-.524c.248-.257.585-.401.937-.4zm12.698 11.333c-.191-1.754-.765-3.009-1.633-3.87-.869-.861-2.135-1.425-3.902-1.606l.198-1.924c2.077.214 3.799.905 5.063 2.156 1.263 1.251 1.968 2.965 2.194 5.035l-1.92.209z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.902 11.976c-.329-2.81-1.267-4.894-2.737-6.352-1.471-1.459-3.568-2.386-6.393-2.701L11.986 1c3.135.35 5.681 1.406 7.538 3.25 1.858 1.843 2.933 4.378 3.298 7.502l-1.92.224z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3z"
  })))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "products",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__produkty"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4458",
    d: "M3 4h4v4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4459",
    d: "M9 4h12v4H9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4460",
    d: "M3 10h4v4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4461",
    d: "M9 10h12v4H9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4462",
    d: "M3 16h4v4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4463",
    d: "M9 16h12v4H9z"
  })))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "publish",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 12.713v7.729h2.666v-7.729l2.348 2.054 1.757-2.007L20 8.003l-5.437 4.757 1.756 2.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 26.664V11.552h-5.333v2.667h2.666v9.778H10.667v-9.778h2.666v-2.667H8v15.112h10.667v2.666h-4v2.667h10.667V29.33h-4.001v-2.666z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_x2F_nastaveni"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.499-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.101c.4.399 1 .399 1.4 0l2.3-2.3c.501-.401.501-1.101.1-1.401z"
  })))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "shield",
    viewBox: "8 8 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.502 19.802-1.934-1.795-3.323 3.58-2.076-1.687-1.663 2.047 3.992 3.244z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.113 8H9.897l-.003 5.276h-.007v2.638h.005l-.005 7.728c0 1.128.584 2.114 1.447 2.689l.005.004L20 32l8.65-5.665.006-.004a3.235 3.235 0 0 0 1.445-2.688v-.001l.006-7.728h.004v-2.638h-.002L30.113 8zm-17.579 2.638h14.938l-.002 2.638H12.532l.002-2.638zm14.931 13.004a.6.6 0 0 1-.27.493l-7.196 4.713-7.205-4.713a.598.598 0 0 1-.269-.493l.005-7.728h14.938l-.003 7.728z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "statistics",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__statistiky"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4453",
    d: "M3 15h4v6H3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4454",
    d: "M10 9h4v12h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4455",
    d: "M17 3h4v18h-4V3z"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "success",
    viewBox: "4 4 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4zm-1.968 17.888-5.048-4.643 2.031-2.208 2.801 2.576 6.312-7.108 2.244 1.992-8.34 9.391z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumb",
    viewBox: "4 4 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic__x2F__thumb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 14.91a2.18 2.18 0 0 0-2.183-2.182h-6.894l1.046-4.985c.022-.109.034-.229.034-.349a1.64 1.64 0 0 0-.481-1.156l-1.155-1.146-7.178 7.178a2.18 2.18 0 0 0-.644 1.549v10.91c0 .578.229 1.133.639 1.541.409.41.964.639 1.542.639h9.818c.905 0 1.681-.545 2.008-1.33l3.294-7.691c.099-.252.154-.513.154-.797V14.91zM4 26.908h4.364v-13.09H4v13.09z"
  })))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "turnon",
    viewBox: "4 4 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__turn_on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zm-1.147-10.747V8h2.295v9.253h-2.295zM8 16c0-2.21.895-4.209 2.343-5.657l1.611 1.611a5.722 5.722 0 1 0 8.092 0l1.611-1.611A8 8 0 0 1 16 23.999 8 8 0 0 1 8 16z"
  })))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "-2 -1 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.108 13.212a11.196 11.196 0 0 0-2.897-2.362 6.14 6.14 0 0 0 2.177-4.693A6.156 6.156 0 0 0 10.23 0a6.156 6.156 0 0 0-6.156 6.157c0 1.794.771 3.403 1.994 4.528-1.205.627-2.283 1.51-3.177 2.526-1.789 2.036-2.969 4.757-2.969 7.474V22h20.154v-1.314c.001-2.717-1.179-5.438-2.968-7.474zM10.23 2.629a3.527 3.527 0 0 1 3.528 3.528 3.527 3.527 0 1 1-7.055 0 3.527 3.527 0 0 1 3.527-3.528zM2.675 19.37c.288-1.573 1.071-3.147 2.191-4.423 1.436-1.633 3.291-2.634 5.134-2.634 1.842 0 3.698 1.001 5.134 2.634 1.12 1.275 1.902 2.85 2.191 4.423H2.675z"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "wallet",
    viewBox: "0.5 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.625h-1.375V8.391c0-.68-.268-1.334-.748-1.818a2.568 2.568 0 0 0-1.637-.754v-2.24a2.58 2.58 0 0 0-.746-1.818A2.553 2.553 0 0 0 17.176 1H5.258a3.748 3.748 0 0 0-2.662 1.111A3.797 3.797 0 0 0 1.5 4.781v14.438c0 .998.393 1.958 1.096 2.668A3.742 3.742 0 0 0 5.258 23h14.3c.686 0 1.34-.275 1.818-.76.48-.485.748-1.139.748-1.818v-2.464H23.5v-7.333zm-2.75 4.583h-3.514c-.313 0-.594-.117-.789-.3a.847.847 0 0 1-.281-.617c0-.213.09-.438.281-.617.195-.183.477-.299.789-.299h3.514v1.833zM4.55 4.047a.996.996 0 0 1 .708-.297h11.734v2.063H5.258a.992.992 0 0 1-.708-.298 1.044 1.044 0 0 1 0-1.468zm14.825 16.202H5.258a.995.995 0 0 1-.708-.296c-.19-.192-.3-.457-.3-.734V8.424c.325.091.664.139 1.008.139h14.117v2.063h-2.139c-.986 0-1.947.366-2.67 1.043a3.597 3.597 0 0 0-1.15 2.623c0 1.002.426 1.944 1.15 2.625a3.906 3.906 0 0 0 2.67 1.042h2.139v2.29z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "zoom",
    viewBox: "-1.5 -2 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.053 13.792a7.473 7.473 0 0 0 2.027-5.129 7.5 7.5 0 1 0-3.299 6.214l3.959 3.96 1.18-1.18-3.867-3.865zm-5.473.705a5.833 5.833 0 0 1-5.833-5.834 5.833 5.833 0 1 1 11.667 0 5.833 5.833 0 0 1-5.834 5.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.414 5.33H8.747v2.5h-2.5v1.667h2.5v2.5h1.667v-2.5h2.5V7.83h-2.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.a5a8ca0769eb9852111244124378695a.svg";
export { ForwardRef as ReactComponent };